// https://www.one.com/ajax-add-transfer-domain.do?move=true
// extraDomainName=amazon&extraDomainSuffix=.asia

export const transferDomain = (domain, tld, authCode) => {
  return (dispatch, getState, { api }) => {
    // API call
    return api.transferDomain(domain, tld, authCode).then(
      (data) => {
        return data;
      },
      (err) => {
        // TODO: Error handling
      },
    );
  };
};
